import axios from 'axios';
const API_URL = `${process.env.REACT_APP_API_URL}/api/client-portal/v1/`;
const getAddress = async (id ) => {

    const res = await axios.get(API_URL + "addresses/"+id)

    return res.data;

}
const AddressService={
    
    getAddress

}

export default AddressService